import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M909.191356,303.659811 L909.191356,404.681073 L101.021262,404.681073 L101.021262,1818.97874 L1515.31893,1818.97874 L1515.31893,1097.48489 L1616.34019,1097.48489 L1616.34019,1920 L0,1920 L0,303.659811 L909.191356,303.659811 Z M1562.13218,0 C1602.64171,0 1640.6257,15.7593168 1669.1137,44.3483339 L1669.1137,44.3483339 L1875.70218,250.835793 C1934.69859,309.933231 1934.69859,406.105473 1875.70218,465.101889 L1875.70218,465.101889 L1666.18408,674.619986 L1316.75154,325.288463 L497.974208,1144.06579 L775.883699,1421.97528 L1499.39798,698.562025 L1570.82001,769.984058 L713.452559,1627.25049 L187.434849,1732.41362 L292.699004,1206.49693 L1454.8476,44.3483339 C1483.43662,15.7593168 1521.52163,0 1562.03116,0 L1562.03116,0 Z M426.552176,1215.48782 L385.840607,1256.30041 L316.337979,1603.71253 L663.750099,1534.2099 L704.461667,1493.39731 L426.552176,1215.48782 Z M1310.55893,538.019036 L1381.98096,609.441068 L757.265481,1234.15655 L685.843449,1162.73452 L1310.55893,538.019036 Z M1562.13218,101.021262 L1562.03116,101.021262 C1548.49431,101.021262 1535.86665,106.274367 1526.26963,115.770366 L1526.26963,115.770366 L1388.17357,253.866431 L1666.18408,531.775922 L1804.28014,393.679857 C1823.87827,373.980711 1823.87827,341.956971 1804.28014,322.156804 L1804.28014,322.156804 L1597.69166,115.770366 C1588.09464,106.173346 1575.46699,101.021262 1562.13218,101.021262 L1562.13218,101.021262 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconComposeLine = /*#__PURE__*/function (_Component) {
  _inherits(IconComposeLine, _Component);

  var _super = _createSuper(IconComposeLine);

  function IconComposeLine() {
    _classCallCheck(this, IconComposeLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconComposeLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconCompose",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconComposeLine.displayName = "IconComposeLine";
  return IconComposeLine;
}(Component);

IconComposeLine.glyphName = 'compose';
IconComposeLine.variant = 'Line';
IconComposeLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconComposeLine;
export { IconComposeLine };